import axios from 'axios';
import { getDerivedApiBaseUrl } from '@/utils/hostOrigins';
import { BILLING_TENANT_STORAGE_KEY } from './billingTenantContext';

const API_BASE_URL = getDerivedApiBaseUrl();

export const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // send cookies (arrangelly_token) to API for cross-subdomain auth
  headers: {
    'Content-Type': 'application/json',
  },
});

// No Authorization header needed - API uses HttpOnly cookie (arrangelly_token) for auth

api.interceptors.request.use((config) => {
  try {
    const path = (config.url ?? '').split('?')[0];
    if (!path.startsWith('/billing')) {
      return config;
    }
    const tenantId = sessionStorage.getItem(BILLING_TENANT_STORAGE_KEY);
    if (!tenantId) {
      return config;
    }
    config.headers = config.headers ?? {};
    if (!config.headers['X-Tenant-Id']) {
      config.headers['X-Tenant-Id'] = tenantId;
    }
  } catch {
    // ignore
  }
  return config;
});

// Handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Only clear auth if this is NOT a login/register/me request
      // (those might fail for other reasons like wrong password, or token validation issues)
      const requestUrl = error.config?.url || '';
      const isAuthRequest =
        requestUrl.includes('/auth/login') ||
        requestUrl.includes('/auth/register') ||
        requestUrl.includes('/auth/forgot-password') ||
        requestUrl.includes('/auth/reset-password') ||
        requestUrl.includes('/auth/me');
      
      if (!isAuthRequest) {
        // Clear auth data silently for non-auth endpoints
        // The webapp has no protected pages, so we never redirect from here
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
      // For auth endpoints, don't clear - let the calling code handle it
    }
    return Promise.reject(error);
  }
);

